export default __webpack_public_path__ + "static/media/imgPerfilDeHierro.9ae6dcd7.png";